var _circle, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPremiumExclusiveDesktop = function SvgPremiumExclusiveDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "var(--color-circle)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.223 16H23.78a3.333 3.333 0 0 0-3.334 3.333v33.334a3.31 3.31 0 0 0 1.711 2.91c.495.28 1.054.426 1.623.423.619 0 1.226-.168 1.755-.489l9.89-6.089a1.088 1.088 0 0 1 1.155 0l9.889 6.09a3.29 3.29 0 0 0 3.377 0 3.311 3.311 0 0 0 1.711-2.912V19.267A3.333 3.333 0 0 0 48.223 16Zm1.111 36.667a1.134 1.134 0 0 1-.578.977 1.088 1.088 0 0 1-1.11 0l-9.89-6.088a3.6 3.6 0 0 0-1.755-.445 3.6 3.6 0 0 0-1.756.489l-9.888 6.089a1.09 1.09 0 0 1-1.112 0 1.134 1.134 0 0 1-.577-.978V19.378a1.111 1.111 0 0 1 1.11-1.111h24.445a1.11 1.11 0 0 1 1.111 1.11v33.29Z",
    fill: "url(#PremiumExclusiveDesktop_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.934 28.22-4.11-.6L38 23.91a2.223 2.223 0 0 0-4 0l-1.822 3.71-4.111.6a2.222 2.222 0 0 0-1.8 1.512 2.223 2.223 0 0 0 .577 2.222l2.956 2.911-.689 4.09a2.222 2.222 0 0 0 .867 2.221 2.222 2.222 0 0 0 2.355.178l3.667-1.933 3.667 1.933c.32.174.68.265 1.044.267.473-.005.933-.16 1.311-.445a2.223 2.223 0 0 0 .867-2.222l-.689-4.089 2.956-2.889a2.223 2.223 0 0 0 .577-2.222 2.222 2.222 0 0 0-1.8-1.533Zm-3.289 5.09a2.222 2.222 0 0 0-.644 1.978l.711 4.089-3.667-1.934a2.223 2.223 0 0 0-1.044-.267 2.223 2.223 0 0 0-1.044.267l-3.667 1.934.711-4.09a2.221 2.221 0 0 0-.644-1.977l-2.978-2.89 4.11-.6a2.221 2.221 0 0 0 1.668-1.221L36 24.888l1.844 3.71a2.222 2.222 0 0 0 1.667 1.223l4.111.6-2.978 2.889Z",
    fill: "url(#PremiumExclusiveDesktop_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PremiumExclusiveDesktop_svg__a",
    x1: 20.445,
    y1: 36,
    x2: 51.556,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PremiumExclusiveDesktop_svg__b",
    x1: 26.176,
    y1: 32.139,
    x2: 45.826,
    y2: 32.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })))));
};

export default SvgPremiumExclusiveDesktop;